import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  AccountSubscription: {
    fields: {
      invoices: {
        keyArgs: ['page', ['first']],
      },
      paymentMethod: {
        merge: true,
      },
      suggestedPlan: {
        merge: false,
      },
      trial: {
        merge: true,
      },
      limitedResources: {
        merge: true,
      },
    },
  },
  LimitedResource: {
    merge: true,
  },
  Share: {
    fields: {
      suggestedPlan: {
        merge: false,
      },
    },
  },
  PlanSuggestion: {
    keyFields: false,
  },
};
